import React from 'react';
import {
    Col, Row, ListGroup, Table, Modal,
    ListGroupItem, Form, FormGroup, ControlLabel, Radio
} from 'react-bootstrap';
import SweetAlert from "react-bootstrap-sweetalert";
import Button from '../../../elements/CustomButton/CustomButton.jsx';
import CriteriaPanel from './CriteriaPanel.jsx';
import ModalRegistro from '../../Components/ModalRegistro.jsx';
import { API_ROOT } from '../../../variables/api-config';
import ModalBlockWrapper from '../../Components/ModalBlockWrapper';

class TutoresSubTab extends React.Component {
  constructor(props) {
    super(props);
    const currentTab = this.props.activeTab ? this.props.activeTab : 0;
    this.state = {
      currentTab,
      projects: this.props.projects.length > 0 ? this.props.projects : [],
      currentProject: this.props.projects.length > 0 ? this.props.projects[currentTab] : [],
      showModal: false,
      error: false,
    };
    this.generateProjectsTabs = this.generateProjectsTabs.bind(this);
    this.switchProject = this.switchProject.bind(this);
    this.handleOnChangeFields = this.handleOnChangeFields.bind(this);
    this.handleMaterialRadio = this.handleMaterialRadio.bind(this);
    this.handleCapacitacionRadio = this.handleCapacitacionRadio.bind(this);
    this.generateRAT = this.generateRAT.bind(this);
    this.saveRat = this.saveRat.bind(this);
    this.setError = this.setError.bind(this);
  }

  switchProject(index) {
    this.setState({ currentTab: index, currentProject: this.state.projects[index] });
  }
  generateProjectsTabs(projects) {
    const html = [];
    projects.forEach((project, index) => {
      html.push(
        <ListGroupItem
          key={index} onClick={this.state.error ? null : () => this.switchProject(index)}
          active={index === this.state.currentTab} disabled={this.state.error}
        >
          {project.name}
        </ListGroupItem>
      );
    });
    return(
      <div style={{ maxHeight: 380, overflowY: 'auto' }}>
        <ListGroup>
          {html}
        </ListGroup>
      </div>
    );
  }
  generateRAT() {
    const html = [];
    this.state.currentProject.RAT.forEach((item, index) => {
      html.push(
        <tr key={index}>
          <td>{item.id}</td>
          <td className="text-center">{item.fecha}</td>
          <td>{item.horas}</td>
          <td className="text-right">
            <Button simple bsStyle="info" bsSize="xs">
              <a href={`${API_ROOT}/pdf/rat?id=${item.id}`}>
                <i className="fa fa-download"></i>
              </a>
            </Button>
          </td>
        </tr>
      )
    });
    return html;
  }
  handleOnChangeFields(value, index, criterio) {
    const auxState = this.state.projects;
    if (auxState[this.state.currentTab].evaluacion[index].idcriterio === criterio) {
      auxState[this.state.currentTab].evaluacion[index].valor = value;
    }
    this.setState({ projects: auxState });
  }
  handleMaterialRadio(value) {
    const auxState = this.state.projects;
    auxState[this.state.currentTab].material = value;
    this.setState({ projects: auxState });
  }
  handleCapacitacionRadio(value) {
    const auxState = this.state.projects;
    auxState[this.state.currentTab].capacitacion = value;
    this.setState({ projects: auxState });
  }
  setError(value) {
    this.setState({ error: value });
  }
  saveRat(rat) {
    this.props.incubationService
      .saveRat(rat)
      .then(res => {
        this.props.showAlert(
            <SweetAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="RAT cargada"
              onConfirm={() => this.props.hideAlert()}
              onCancel={() => this.props.hideAlert()}
              confirmBtnBsStyle="info"
              confirmBtnText="Aceptar"
            >
              {'Cambios guardados satisfactoriamente!'}
            </SweetAlert>
          );
        this.setState({showModal: false});
        this.props.refresh(this.state.currentTab);
      })
      .catch(err => {
        this.props.setError((<div>Ha ocurrido un error mientras se guardaban los datos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }
  render() {
    return(
      <div>
        <div>
          <Row>
            <Col md={4}>
              <h6>Proyectos asignados</h6><br/>
              {this.generateProjectsTabs(this.state.projects)}
            </Col>
            <Col md={4}>
              <h6>Criterios de evaluación</h6><br/>
              <CriteriaPanel
                handleOnChangeFields={this.handleOnChangeFields} evaluacion={this.state.currentProject.evaluacion}
                setError={this.setError} error={this.state.error}
              />
            </Col>
            <Col md={4}>
              <h6>Requisitos</h6><br/>
              <Form horizontal={true}>
                <FormGroup >
                  <Col componentClass={ControlLabel} md={4} style={{textAlign:'left'}}>
                    Material
                  </Col>
                  <Col md={8}>
                    <Radio
                      name="radioGroup1" inline checked={this.state.projects[this.state.currentTab].material === '1'}
                      onChange={() => this.handleMaterialRadio('1')}
                    >
                      B
                    </Radio>{' '}
                    <Radio
                      name="radioGroup1" inline checked={this.state.projects[this.state.currentTab].material === '2'}
                      onChange={() => this.handleMaterialRadio('2')}
                    >
                      R
                    </Radio>{' '}
                    <Radio
                      name="radioGroup1" inline checked={this.state.projects[this.state.currentTab].material === '3'}
                      onChange={() => this.handleMaterialRadio('3')}
                    >
                      M
                    </Radio>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col componentClass={ControlLabel} md={4} style={{textAlign:'left'}}>
                    Capacitación
                  </Col>
                  <Col md={8}>
                    <Radio
                      name="radioGroup2" inline checked={this.state.projects[this.state.currentTab].capacitacion === '1'}
                      onChange={() => this.handleCapacitacionRadio('1')}
                    >
                      B
                    </Radio>{' '}
                    <Radio
                      name="radioGroup2" inline checked={this.state.projects[this.state.currentTab].capacitacion === '2'}
                      onChange={() => this.handleCapacitacionRadio('2')}
                    >
                      R
                    </Radio>{' '}
                    <Radio
                      name="radioGroup2" inline checked={this.state.projects[this.state.currentTab].capacitacion === '3'}
                      onChange={() => this.handleCapacitacionRadio('3')}
                    >
                      M
                    </Radio>
                  </Col>
                </FormGroup>
              </Form>
              <br/>
              <h6>Registro asistencia tecnica</h6><br/>
              <Row>
                {this.state.currentProject.RAT.length > 0 ?
                  <div style={{maxHeight: 300, overflowY: 'auto'}}>
                    <Table responsive={true}>
                      <thead>
                        <tr>
                          <th>Nº</th>
                          <th className="text-center">Fecha y Hora</th>
                          <th>horas</th>
                          <th className="text-right"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.generateRAT()}
                      </tbody>
                    </Table>
                  </div> :
                  <div style={{ textAlign: 'center' }}>No hay Registros</div>
                }
                <div style={{textAlign:'right', paddingRight:'15px', paddingTop: '15px'}}>
                  <Button bsStyle="info" bsSize="sm" fill wd onClick={() => this.setState({ showModal: true })}>
                    Cargar RAT
                  </Button>
                </div>
              </Row>
            </Col>
          </Row>
          <div style={{textAlign:'right', paddingTop:'10px'}}>
            {this.state.error &&
              <small className="text-danger">
                La calificación debe ser entre 0 y 10
              </small>
            }
            {'    '}
            <Button
              bsStyle="primary" fill wd onClick={() => this.props.saveEvaluation(this.state.projects)}
              disabled={this.state.error}
            >
              Guardar
            </Button>
          </div>
        </div>
        <Modal show={this.state.showModal} onHide={() => this.setState({showModal: false})} bsSize="large">
          <ModalBlockWrapper
            content={
              <div>
                <Modal.Header closeButton>
                  <Modal.Title>Registro de Asistencia Técnica</Modal.Title>
                </Modal.Header>
                <ModalRegistro
                  type="RAT"
                  nombreproyecto={this.state.currentProject.name} estado={'Pre Seleccion'}
                  cancel={() => this.setState({showModal: false})}
                  save={(rat) => this.saveRat(rat)} idproyecto={this.state.currentProject.id}
                  setError={this.setError}
                />
              </div>
            }
          />
        </Modal>
      </div>
    );
  }
}

export default TutoresSubTab;



// WEBPACK FOOTER //
// ./src/views/Incubation/PreSelectionComponents/TutoresSubTab.jsx